import React, { useState } from 'react'

import { useParams } from 'react-router-dom'

import useFetch from 'hooks/useFetch'
import * as service from 'service'

import InvalidLinkScreen from 'views/Training/Journey/components/InvalidLinkScreen'
import IdentificationStep from './components/IdentificationStep'
import VerifyCodeStep from './components/VerifyCodeStep'

const InviteCourse = () => {
  const { portalToken, coursePublicToken } = useParams()

  const [activeStep, setActiveStep] = useState(0)
  const [formData, setFormData] = useState(null)

  const { response, isLoading, error } = useFetch(
    service.trainingPortal.inviteCourse.show,
    { publicToken: coursePublicToken, portalToken },
    [coursePublicToken, portalToken],
  )

  const courseInfo = response?.data

  const handleIdentificationSuccess = (data) => {
    setFormData(data)
    setActiveStep(1)
  }

  const handleVerifySuccess = (token) => {
    service.trainingPortal.auth.setToken(token)
    service.history.push(`/training/${portalToken}/home`)
  }

  const handleBack = () => {
    setActiveStep(0)
  }

  if (!isLoading && (error || !courseInfo)) return <InvalidLinkScreen />

  if (isLoading) return null

  return activeStep === 0 ? (
    <IdentificationStep
      courseTitle={courseInfo?.course?.title}
      loginMode={courseInfo?.loginMode}
      publicToken={coursePublicToken}
      portalToken={portalToken}
      onSuccess={handleIdentificationSuccess}
    />
  ) : (
    <VerifyCodeStep
      publicToken={coursePublicToken}
      portalToken={portalToken}
      formData={formData}
      onSuccess={handleVerifySuccess}
      onBack={handleBack}
    />
  )
}

export default InviteCourse
